export default __webpack_public_path__ + "static/media/iso9001.5f74dfc7.jpg";